<template>
  <div class="main-page">
    <div class='top-menu text-color'>{{headTitle}}
      <!-- <i class="ico_logo_portal"></i> -->
      <div class="head-title" @click="onClickHome">
        <img src="/image/career_high.png" style="height:59px"/>
      </div>
      <div class='user-info'  @click='onMyPage'><img :src='userImage'></div>
      <div class='user-name text-color'>{{userInfo.userName}}</div>
    </div>
    <router-view @titleFromChild="onTitleChanged" />
    <LeftMenuDropDownComponent v-if='topMenu' :menuList='topMenu' @titleFromChild="onTitleChanged" ref='topMenuComponent'/>
  </div>

</template>

<script>

import ConstDef from '../share/ConstDef'
// import { DxSelectBox, DxCheckBox, DxTextBox, DxDateBox, DxButton } from 'devextreme-vue'
// import { DxButton } from 'devextreme-vue'
import LeftMenuDropDownComponent from '../share/component/navigation-component/LeftMenuDropDownComponent'
import FindAllTopMenuProc from '../share/service/FindAllTopMenuProc'
// import AppLib from '../share/AppLib'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      topMenuHeight: null,
      topMenu: null,
      userInfo: null,
      userImage: '/image/user-circle.png',
      headTitle: '-'

    }
  },
  components: {
    LeftMenuDropDownComponent
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === undefined || this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.init()
  },

  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  updated () {
    // this.$Q('.sub-content').css('width', (window.innerWidth - 300) + 'px')
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    async init () {
      // console.log(this.userInfo)
      if (this.userInfo.userImage !== null) {
        this.userImage = ConstDef.apiUrl + '/imgLoadAll?file=' + this.userInfo.userImage
      }
      // let baseData = this.$store.getters.getBaseData
      // // console.log(baseData)
      const homePath = '/main/home'
      let baseData = null
      if (baseData === null) {
        const findTopMenu = FindAllTopMenuProc.SendParamModel()
        const baseCode = this.$_sp.runFindSqlProc('공통코드', null)
        const topMenuTab = this.$_sp.runFindProc('spFindAllTopMenuForTabName', {})
        const employee = this.$_sp.runFindSqlProc('직원정보', null)
        axios.all([findTopMenu, baseCode, topMenuTab, employee])
          .then(axios.spread((...reponse) => {
            if (reponse[0].result === ConstDef.SUCCESS) {
              this.topMenu = FindAllTopMenuProc.MakeModel(reponse[0], this.$store)
              // console.log(this.topMenu)
              this.$store.commit('saveBaseData', this.$_sp.MakeModel(reponse[1]))
              this.$store.commit('saveTopMenuTab', this.$_sp.MakeModel(reponse[2]))
              const temp = this.$_.sortBy(this.$_sp.MakeModel(reponse[3]), '성명')
              // console.log(temp)
              this.$store.commit('saveEmployee', temp)
              if (this.$route.path === '/main') {
                this.$router.push(homePath)
                console.log(this.topMenu)
                const where = this.$_.findWhere(this.topMenu, { url: homePath })
                console.log(where)
                if (where !== undefined) {
                  this.headTitle = `${where.caption}`
                  return false
                }
              }
            }
          }))
      } else {
        FindAllTopMenuProc.SendParamModel()
          .then((data) => {
            this.isLoading = false
            if (data.result === ConstDef.SUCCESS) {
              this.topMenu = FindAllTopMenuProc.MakeModel(data, this.$store)
              if (this.$route.path === '/main') {
                this.$router.push(homePath)
                console.log(this.topMenu)
                const where = this.$_.findWhere(this.topMenu, { url: homePath })
                console.log(where)
                if (where !== undefined) {
                  this.headTitle = `${where.caption}`
                  return false
                }
              }
            }
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    onClickHome (e) {
      // console.log(e)
      this.$router.push('/main/home')
    },
    onResize (e) {
      // this.$Q('.sub-content').css('width', (window.innerWidth - 300) + 'px')
      // this.$Q('.sub-content').css('height', (window.innerHeight - 60) + 'px')
    },
    onTitleChanged (title) {
      // console.log(title)
      this.headTitle = title
    },
    gotoDefaultPage () {
      let permission = this.$store.getters.getUserInfo.permission
      // console.log(permission)
      for (let i = 0; i < this.topMenu.length; i++) {
        for (let j = 0; j < this.topMenu[i].subMenu.length; j++) {
          if (this.topMenu[i].subMenu[j].permission & permission) {
            // console.log(this.topMenu[i].subMenu[j].url)
            return this.topMenu[i].subMenu[j].url
          }
        }
      }
    },
    onLogout (e) {
      this.userInfo = this.$store.getters.getUserInfo
      this.$router.push('/logout')
    },
    onHome () {
      let current = this.$route.path
      let home = this.gotoDefaultPage()
      if (current !== home) {
        this.$router.push(this.gotoDefaultPage())
        this.$refs.topMenuComponent.selectSubMenu()
      }
    },
    onMyPage () {
      // // console.log(this.$route)
      this.$router.push(`/myPage?beforeUrl=${this.$route.path}`)
    }
  }
}

</script>

<style lang="scss">
.main-page{
  .text-color{
    color:#363640;
  }
  i.ico_logo_portal {
    position: absolute;
    top: 15px;
    left: 100px;
    width: 226px;
    height: 37px;
    background: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 232.15 28.34'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23383649;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='logo'%3E%3Cpath class='cls-1' d='M29,10.71a2.65,2.65,0,0,1,1.63-.46,2.29,2.29,0,0,1,1.61.54,1.92,1.92,0,0,1,.6,1.51h3.84a4.53,4.53,0,0,0-.76-2.59A4.84,4.84,0,0,0,33.8,8a7.44,7.44,0,0,0-3.09-.61,8.61,8.61,0,0,0-3.17.56,5,5,0,0,0-2.19,1.58,3.74,3.74,0,0,0-.77,2.34c0,1.78,1,3.17,3.1,4.19a21,21,0,0,0,2.45,1,7.3,7.3,0,0,1,2.1,1,1.59,1.59,0,0,1,.6,1.32,1.34,1.34,0,0,1-.55,1.15,2.44,2.44,0,0,1-1.51.41,3.16,3.16,0,0,1-2.15-.6,2.44,2.44,0,0,1-.67-1.9H24.09a5,5,0,0,0,.8,2.8,5.31,5.31,0,0,0,2.37,1.9,8.5,8.5,0,0,0,3.51.7,7,7,0,0,0,4.33-1.2,3.89,3.89,0,0,0,1.58-3.28,4.58,4.58,0,0,0-2.59-4.12A13.74,13.74,0,0,0,31.37,14a8.59,8.59,0,0,1-2.31-1,1.41,1.41,0,0,1-.66-1.11A1.39,1.39,0,0,1,29,10.71Z'/%3E%3Cpolygon class='cls-1' points='37.9 10.54 42.6 10.54 42.6 23.53 46.45 23.53 46.45 10.54 51.23 10.54 51.23 7.57 37.9 7.57 37.9 10.54'/%3E%3Cpath class='cls-1' d='M64.09,15.15a5.27,5.27,0,0,0,.67-2.76,4.25,4.25,0,0,0-1.6-3.56,7,7,0,0,0-4.44-1.26H52.44v16h3.85V17.88h2.08l2.82,5.65h4.12v-.17L62,16.92A4.8,4.8,0,0,0,64.09,15.15Zm-3.72-.8a2.2,2.2,0,0,1-1.65.57H56.29V10.53h2.43a2.13,2.13,0,0,1,1.64.59,2.22,2.22,0,0,1,.56,1.62A2.23,2.23,0,0,1,60.37,14.35Z'/%3E%3Cpath class='cls-1' d='M72.07,7.57l-5.86,16h4.11l.92-3h5.28l.93,3h4.13l-5.9-16Zm.09,10L73.88,12l1.72,5.54Z'/%3E%3Cpath class='cls-1' d='M18.28,7.58H14.21v6.85a5.08,5.08,0,1,1-10.15,0V2.48L0,0V14.43a9.14,9.14,0,0,0,1.54,5.08A9.3,9.3,0,0,0,4.06,22a9.13,9.13,0,0,0,10.15,0,9.33,9.33,0,0,0,2.53-2.52,9.14,9.14,0,0,0,1.54-5.08Z'/%3E%3Cpath class='cls-1' d='M20.29,19.51a2,2,0,1,0,2,2A2,2,0,0,0,20.29,19.51Z'/%3E%3Cpath class='cls-1' d='M96.86,15.15a4.09,4.09,0,0,0,1.64-1.29,3.27,3.27,0,0,0,.64-2,3.91,3.91,0,0,0-1.32-3.2A6.13,6.13,0,0,0,93.9,7.58H88.67v16h5.55a5.81,5.81,0,0,0,4-1.24,4.3,4.3,0,0,0,1.4-3.39,3.91,3.91,0,0,0-.76-2.43A3.7,3.7,0,0,0,96.86,15.15Zm-6-5.77H93.9a3.69,3.69,0,0,1,2.31.59A2.25,2.25,0,0,1,97,11.84a2.26,2.26,0,0,1-.82,1.84,3.22,3.22,0,0,1-2.17.68H90.84ZM96.55,21a3.31,3.31,0,0,1-2.29.75H90.84V16.13H94.3c2,0,3.08.95,3.08,2.83A2.64,2.64,0,0,1,96.55,21Z'/%3E%3Cpath class='cls-1' d='M102.94,7.36a1.16,1.16,0,0,0-.92.36,1.27,1.27,0,0,0-.31.85,1.25,1.25,0,0,0,.31.85,1.26,1.26,0,0,0,1.85-1.7A1.17,1.17,0,0,0,102.94,7.36Z'/%3E%3Crect class='cls-1' x='101.88' y='11.67' width='2.1' height='11.9'/%3E%3Cpolygon class='cls-1' points='114.87 13.16 114.88 13.15 114.88 11.67 105.84 11.67 105.84 13.42 112.23 13.42 105.75 22.02 105.75 22.03 105.75 23.57 115.21 23.57 115.21 21.84 108.33 21.84 114.87 13.16'/%3E%3Cpath class='cls-1' d='M123,7.58h-5.91v16h2.18V17.34H123a6.23,6.23,0,0,0,4.18-1.26,4.55,4.55,0,0,0,1.46-3.6,4.6,4.6,0,0,0-1.5-3.56A6,6,0,0,0,123,7.58Zm2.55,7.18a3.76,3.76,0,0,1-2.55.78h-3.73V9.38h3.84a3.52,3.52,0,0,1,2.44.87,3,3,0,0,1,.88,2.25A2.89,2.89,0,0,1,125.54,14.76Z'/%3E%3Crect class='cls-1' x='130.43' y='6.71' width='2.1' height='16.86'/%3E%3Cpath class='cls-1' d='M142.37,20.3a3,3,0,0,1-3,1.69c-1.44,0-2.14-.87-2.14-2.65V11.67h-2.1V19.4a4.82,4.82,0,0,0,1,3.27A3.71,3.71,0,0,0,139,23.78a4.37,4.37,0,0,0,3.42-1.32l0,1.11h2V11.67h-2.11Z'/%3E%3Cpath class='cls-1' d='M154,17.47a11.4,11.4,0,0,0-2.46-.81,7.16,7.16,0,0,1-2.08-.7,1.2,1.2,0,0,1-.56-1.07,1.46,1.46,0,0,1,.61-1.23,2.75,2.75,0,0,1,1.7-.47,2.63,2.63,0,0,1,1.75.59,1.78,1.78,0,0,1,.69,1.4v0h2.11v0a3.34,3.34,0,0,0-1.27-2.68,5,5,0,0,0-3.28-1.05,4.89,4.89,0,0,0-3.17,1A3.15,3.15,0,0,0,146.78,15a2.67,2.67,0,0,0,.44,1.53,3.48,3.48,0,0,0,1.35,1.11,10.58,10.58,0,0,0,2.44.79,5.86,5.86,0,0,1,2.14.77,1.45,1.45,0,0,1,.6,1.24,1.4,1.4,0,0,1-.68,1.21,3.25,3.25,0,0,1-1.82.45,3.15,3.15,0,0,1-2-.58,2.05,2.05,0,0,1-.79-1.58v0h-2.09v0a3.45,3.45,0,0,0,.62,2,4.07,4.07,0,0,0,1.73,1.42,6.09,6.09,0,0,0,2.52.5,5.4,5.4,0,0,0,3.32-1,3.08,3.08,0,0,0,1.28-2.57,2.9,2.9,0,0,0-.46-1.64A3.76,3.76,0,0,0,154,17.47Z'/%3E%3Cpath class='cls-1' d='M171.89,15.77a13.27,13.27,0,0,0-3.11-1.23A8.14,8.14,0,0,1,166,13.32a2,2,0,0,1-.81-1.62A2.28,2.28,0,0,1,166,9.83a3.87,3.87,0,0,1,2.4-.67A3.66,3.66,0,0,1,171,10a2.86,2.86,0,0,1,.9,2.24v0h2.19v0a4.57,4.57,0,0,0-.71-2.46,4.84,4.84,0,0,0-2-1.76,6.65,6.65,0,0,0-2.94-.64A6,6,0,0,0,164.5,8.6,3.89,3.89,0,0,0,163,11.74a3.72,3.72,0,0,0,1.24,2.82,10.06,10.06,0,0,0,3.95,1.92,9.43,9.43,0,0,1,3,1.25,2.12,2.12,0,0,1,.81,1.78,2.18,2.18,0,0,1-.87,1.81,4.13,4.13,0,0,1-2.52.67,4.44,4.44,0,0,1-2.82-.83,2.69,2.69,0,0,1-1.05-2.24v0h-2.19v0a4.22,4.22,0,0,0,.78,2.5,5.15,5.15,0,0,0,2.2,1.73,7.54,7.54,0,0,0,3.08.63,6.47,6.47,0,0,0,4.05-1.17,3.77,3.77,0,0,0,1.52-3.13,4.05,4.05,0,0,0-.54-2.12A4.79,4.79,0,0,0,171.89,15.77Z'/%3E%3Cpath class='cls-1' d='M180.42,20.44l-2.91-8.75v0h-2.29l4.23,11.72L179,24.58a2.89,2.89,0,0,1-.93,1.5,2.64,2.64,0,0,1-1.57.41l-.59,0v1.72l.79.15.39,0c1.61,0,2.8-1,3.54-3l4.77-13.69h-2.25Z'/%3E%3Cpath class='cls-1' d='M193.47,17.47a11.6,11.6,0,0,0-2.46-.81,7.16,7.16,0,0,1-2.08-.7,1.2,1.2,0,0,1-.56-1.07,1.48,1.48,0,0,1,.6-1.23,2.78,2.78,0,0,1,1.71-.47,2.65,2.65,0,0,1,1.75.59,1.81,1.81,0,0,1,.69,1.4v0h2.11v0A3.34,3.34,0,0,0,194,12.5a5,5,0,0,0-3.28-1.05,4.88,4.88,0,0,0-3.17,1A3.15,3.15,0,0,0,186.27,15a2.67,2.67,0,0,0,.43,1.53,3.55,3.55,0,0,0,1.35,1.11,10.68,10.68,0,0,0,2.45.79,5.72,5.72,0,0,1,2.13.77,1.46,1.46,0,0,1,.61,1.24,1.4,1.4,0,0,1-.68,1.21,3.27,3.27,0,0,1-1.82.45,3.13,3.13,0,0,1-2-.58,2.09,2.09,0,0,1-.8-1.58v0h-2.1v0a3.39,3.39,0,0,0,.63,2,4.1,4.1,0,0,0,1.72,1.42,6.11,6.11,0,0,0,2.53.5,5.35,5.35,0,0,0,3.31-1,3.09,3.09,0,0,0,1.29-2.57,2.9,2.9,0,0,0-.46-1.64A3.76,3.76,0,0,0,193.47,17.47Z'/%3E%3Cpath class='cls-1' d='M201.67,22a1.25,1.25,0,0,1-1-.34,1.61,1.61,0,0,1-.28-1v-7.3h2.2V11.67h-2.2V8.81h-2.1v2.86h-2.16v1.64h2.16V20.6A3.58,3.58,0,0,0,199,23a2.6,2.6,0,0,0,2.08.83,6.15,6.15,0,0,0,1.56-.21h0V21.85h0A4.56,4.56,0,0,1,201.67,22Z'/%3E%3Cpath class='cls-1' d='M208.7,11.45a4.75,4.75,0,0,0-2.64.79,5.27,5.27,0,0,0-1.89,2.17,7.19,7.19,0,0,0-.68,3.16v.37A5.9,5.9,0,0,0,205,22.19,5.21,5.21,0,0,0,209,23.78a5,5,0,0,0,4.49-2.3l0,0-1.26-1,0,0,0,0a4.49,4.49,0,0,1-1.29,1.14,3.44,3.44,0,0,1-1.79.43A3.19,3.19,0,0,1,206.6,21a4.2,4.2,0,0,1-1-2.75h8v-.89A6.62,6.62,0,0,0,212.31,13,4.46,4.46,0,0,0,208.7,11.45Zm2.8,5h-5.84a4.28,4.28,0,0,1,1-2.42,2.63,2.63,0,0,1,2-.88,2.52,2.52,0,0,1,2,.83,3.83,3.83,0,0,1,.82,2.36Z'/%3E%3Cpath class='cls-1' d='M228.15,11.45a4.45,4.45,0,0,0-3.76,1.86A3.43,3.43,0,0,0,221,11.45a4.4,4.4,0,0,0-3.47,1.47l0-1.25h-2v11.9h2.11V14.91a2.67,2.67,0,0,1,2.68-1.67c1.67,0,2.48.83,2.48,2.54v7.79h2.11V15.69a2.6,2.6,0,0,1,2.69-2.45,2.53,2.53,0,0,1,1.92.62,2.73,2.73,0,0,1,.56,1.87v7.84h2.11v-8C232.1,12.85,230.76,11.45,228.15,11.45Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
  .top-menu{
    position: fixed;
    z-index: 100;
    height:60px;
    width:100%;
    background-color: white;
    border-bottom: 1px solid rgb(68, 62, 62);
    line-height: 60px;
    font-size: 18px;
    text-align: center;
    .head-title{
      position:absolute;
      top: 0px;
      left: 80px;
      font-weight: bold;
      color: black;
      font-size: 1.8rem;
    }
    .logo {
      position:absolute;
      top: 8px;
      left: 90px;
      text-decoration: none;
      display: block;
    }
    .user-info {
      position:absolute;
      right:20px;
      color:white;
      top:8px;
      border-radius: 50%;
      height:40px;
      width:40px;
      overflow: hidden;
      img{
        width:100%;
      }
    }
    .user-name {
      position:absolute;
      right:70px;
      width:85px;
      color:#363640;
      top:0px;
      font-size: 14px;
      overflow: hidden;
      text-align: center;
    }
    .user-info:hover {
      cursor: pointer;
    }
    .log-out{
      position:absolute;
      right:10px;
      color:#383649;
    }
  }
}

</style>
